import axios from "axios";
import axiosInstance from "../../translator";
import { translator } from "../../constants/actionTypes";
import { localStorageHelper } from "../../utils/storageHelper";
import { machineCatalogueAPI as machineCatalogue, machineCatalogueAPI, tenantManagementAPI } from "../../constants/apis/apiEndpoints";

export const fetchSkusList = async (url) => {
  return axiosInstance
    .get(url)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const createCatalogApi = async (urlParams) => {
  return axiosInstance
    .post(machineCatalogue?.catalogues, urlParams)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const editCatalogApi = async (urlParams) => {
  let url = `${machineCatalogueAPI?.updateCatalogChanges}`;
  if (urlParams?.isMasterCatalog) {
    url = `${machineCatalogue?.catalogue_master}${url}`;
  } else {
    url = `${machineCatalogueAPI?.catalogueDraft}${url}`;
  }
  return axiosInstance
    .post(url, urlParams?.formData)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const catalogBulkUploadApi = async (data) => {
  return axios
    .post(`${translator?.baseURL}${machineCatalogue?.csvUpload}`, data, {
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
        tenant: localStorageHelper.get("tenantId"),
        accessToken: `Bearer ${localStorageHelper.get("accessToken")}`,
        Authorization: `${localStorageHelper.get("authToken")}`,
        role: localStorageHelper.get("role"),
        authtype: localStorageHelper.get("auth_type"),
      },
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const removeSkuApi = async (id) => {
  return axiosInstance
    .delete(`${machineCatalogueAPI?.catalogueDraft}/${id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const addSkuApi = async (data) => {
  let url = `${machineCatalogueAPI?.catalogueDraft}${machineCatalogueAPI?.updateCatalogEndpoint}`;
  if (data?.url) {
    url = `${url}${data?.url}`;
  }

  return axiosInstance
    .post(url, data?.formData)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const retireSkuApi = async (data) => {
  let url = data?.isMasterCatalog
    ? `${machineCatalogueAPI?.catalogue_master}${machineCatalogueAPI?.updateCatalogMasterEndpoint}`
    : `${machineCatalogueAPI?.catalogueDraft}${machineCatalogueAPI?.updateCatalogEndpoint}`;
  if (data?.url) {
    url = `${url}${data?.url}`;
  }

  return axiosInstance
    .post(url, data?.formData)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const azureReportDownloadApi = async (payload) => {
  return axiosInstance
    .post(machineCatalogue?.azureReportDownload, payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const cleanUpAzureApi = async (id) => {
  return axiosInstance
    .get(machineCatalogue?.cleanUpAzure, { params: id })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const syncBillApi = async (data) => {
  return axiosInstance
    .patch(`${machineCatalogue?.syncBill}/${data?.id}`, {})
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const awsCleanupApi = async (data) => {
  return axiosInstance
    .get(`${machineCatalogue?.awsCleanup}/${data?.id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const getMentorListApi = async (urlParams) => {
  return axiosInstance
    .get(`${tenantManagementAPI?.usersByRoleEndpoint}${urlParams || ""}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};